import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function Hero() {
  return <section className="pt-6 pb-8 px-4 relative overflow-hidden" data-id="element-148">
      <div className="max-w-md sm:max-w-lg mx-auto text-center relative z-10" data-id="element-149">
        {/* Attention pill */}
        <motion.div initial={{
        opacity: 0,
        y: -10
      }} animate={{
        opacity: 1,
        y: 0
      }} className="inline-flex items-center gap-2 bg-brand-card border border-brand-danger/40 px-4 py-1.5 rounded-full mb-5" data-id="element-150">
          <span className="w-2 h-2 rounded-full bg-brand-danger animate-pulse" data-id="element-151" />
          <span className="text-[11px] sm:text-xs font-black tracking-wider text-brand-danger uppercase" data-id="element-152">
            ATTENZIONE: DOCENTI DI LETTERE DI SCUOLA SECONDARIA STANCHI DI
            SACRIFICARE LE PROPRIE SERATE A PIANIFICARE
          </span>
        </motion.div>

        {/* Headline */}
        <motion.h1 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.05
      }} className="text-[28px] sm:text-4xl font-black text-brand-cream leading-[1.1] mb-4" data-id="element-153">
          L'intero anno di{' '}
          <span className="relative inline-block" data-id="element-154">
            <span className="bg-gradient-to-r from-brand-orange to-brand-amber bg-clip-text text-transparent" data-id="element-155">
              Lingua e Letteratura
            </span>
            <span className="absolute left-0 right-0 -bottom-1 h-[3px] bg-gradient-to-r from-brand-orange to-brand-amber rounded-full" data-id="element-156" />
          </span>
          , pronto in <span className="text-brand-gold" data-id="element-157">5 minuti.</span>
        </motion.h1>

        {/* Subheadline */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.1
      }} className="bg-brand-card border-l-4 border-brand-orange rounded-r-xl p-4 sm:p-5 mb-6 text-left" data-id="element-158">
          <p className="text-base sm:text-lg text-gray-300 leading-snug" data-id="element-159">
            Il primo kit{' '}
            <span className="text-brand-orange font-bold" data-id="element-160">
              "Apri e Insegna"
            </span>{' '}
            con{' '}
            <span className="text-brand-cream font-bold" data-id="element-161">
              6 Tomi completi e lezioni già pronte
            </span>{' '}
            per Medie e Superiori.{' '}
            <span className="text-brand-cream font-bold" data-id="element-162">
              Recupera i tuoi Weekend e stupisci i tuoi alunni.
            </span>
          </p>
        </motion.div>

        {/* Product image */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        delay: 0.15
      }} className="mb-6" data-id="element-163">
          <a href="#pricing" className="block cursor-pointer" data-id="element-164">
            <img src="https://cdn.magicpatterns.com/uploads/aVHrhd3pNybszQwHRcKbHa/my-project-page-1_(2).png" alt="Lettere Pronte — Kit Scuola Secondaria" className="w-full h-auto object-contain drop-shadow-2xl scale-110" data-id="element-165" />
          </a>
        </motion.div>

        {/* Brand line */}
        <motion.p initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        delay: 0.18
      }} className="text-sm font-bold text-brand-cream mb-2" data-id="element-166">
          Lettere Pronte — Kit Scuola Secondaria
        </motion.p>

        {/* Star rating */}
        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        delay: 0.2
      }} className="flex items-center justify-center gap-2 mb-3" data-id="element-167">
          <div className="flex" data-id="element-168">
            {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-5 h-5 text-brand-gold fill-current drop-shadow-[0_0_6px_rgba(251,191,36,0.6)]" data-id="element-169" />)}
          </div>
          <span className="text-sm font-bold text-brand-cream" data-id="element-170">
            4.9/5 (+800 Recensioni Verificate)
          </span>
        </motion.div>

        {/* Scarcity pill */}
        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        delay: 0.25
      }} className="inline-flex items-center gap-2 border border-brand-orange/40 bg-brand-orange/5 px-4 py-1.5 rounded-full mb-5" data-id="element-171">
          <span className="text-sm font-bold text-brand-orange" data-id="element-172">
            🔥 84 insegnanti hanno scelto questo Kit oggi
          </span>
        </motion.div>

        {/* Main CTA */}
        <motion.div initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.3
      }} data-id="element-173">
          <CTAButton className="w-full" data-id="element-174">
            SÌ! VOGLIO RECUPERARE IL MIO TEMPO
          </CTAButton>
        </motion.div>

        {/* Trust line */}
        <div className="flex flex-wrap justify-center items-center gap-x-3 gap-y-1 mt-5 text-xs text-gray-400 font-medium" data-id="element-175">
          <span data-id="element-176">⚡ Accesso immediato</span>
          <span className="text-gray-600" data-id="element-177">•</span>
          <span data-id="element-178">🛡️ Garanzia 14 giorni</span>
          <span className="text-gray-600" data-id="element-179">•</span>
          <span data-id="element-180">💳 Pagamento Unico</span>
        </div>

        {/* Country line */}
        <div className="mt-6 flex flex-col items-center gap-2" data-id="element-181">
          <div className="flex items-center justify-center gap-2" data-id="element-182">
            <div className="w-7 h-7 rounded-full overflow-hidden border border-white/20 shadow" data-id="element-183">
              <img src="https://flagcdn.com/w80/it.png" alt="Italia" className="w-full h-full object-cover" data-id="element-184" />
            </div>
          </div>
          <p className="text-[11px] text-gray-500 font-medium" data-id="element-185">
            🇮🇹 La risorsa N.1 scelta da oltre 800 docenti in tutta Italia.
          </p>
        </div>
      </div>
    </section>;
}